import React from 'react';
import { componentService } from 'js/services/component.service';

export const Veridas = React.lazy(() => import(/* webpackChunkName: "veridas" */ './Veridas'));

componentService.registerPageComponents({ veridas: Veridas });
